module.exports = __webpack_public_path__ + "static/portraitDesk-93aeaae877fdf95d2ee37dd8fefac3be.png";